import AesUtils from "./AesUtils";
import Storage from "@/uitls/Storage";
import axios from "axios";
import Platform from "@/config/platform";
export const createImNetWork = () => {
  const ApiNetWork = class {
    private address?: any;

    get(url: string, data: any = {}) {
      return new Promise((resolve, reject) => {
        this.request(url, data, (e: any, result: any) => {
          if (result) {
            resolve(result);
          } else {
            reject(e);
          }
        });
      });
    }
    getAddress = () => {
      //第一次进来，获取历史的baseurl
      let _url = Storage.get("DOMAIN_LIST_PHP");

      const Api = 'https://jk.qawsrt.cn,https://jk.vxcus.cn,https://jk.vxcvasdf.cn,https://jk.ssadf.cn';
      const ApiList: Array<string> = Api.split(",");
      if (_url == null || _url == "") {
        _url = ApiList[Math.floor(Math.random() * ApiList.length)];
      }
      if (_url[_url.length - 1] != "/") {
        _url = _url + "/";
      }
      this.address = _url;
      this.checkHttp(ApiList, true);
      return _url;
    };

    //检查域名是否可用
    async checkHttp(ApiList: Array<string>, doAdmin = false) {
      for (let i = 0; i < ApiList.length; i++) {
        //循环发送网络请求
        let _url = ApiList[i];
        if (_url[_url.length - 1] != "/") {
          _url = _url + "/";
        }
        const res: any = await this.get("app/encryptionVersion");
        if (res.code == "200") {
          this.address = _url;
          Platform.address = _url;
          Storage.set("DOMAIN_LIST_PHP", _url);

          return;
        }
      }

      //要不要去请求桶地址
      if (doAdmin) {
        this.toMains();
      }
    }

    //去请求桶拿地址
    toMains() {
      console.log("这几个域名都不通。准备去请求桶");
      // VITE_TXDOMAINCONFIG
      const txUri = 'https://livejk-1309827338.cos.accelerate.myqcloud.com/domain.config';
      const aliUri = 'https://f7tv.oss-cn-hongkong.aliyuncs.com/domain.config';
      const appID = 'com.btv.livetv';

      // 请求腾讯桶
      axios.get(txUri).then((response) => {
        if (response.status == 200) {
          const d: Array<string> = response.data[appID];
          this.checkHttp(d, false);
        }
      });
      // 请求阿里桶
      axios.get(aliUri).then((response) => {
        if (response.status == 200) {
          const d: Array<string> = response.data[appID];
          this.checkHttp(d, false);
        }
      });
    }

    buildUrl(url: any, params: any) {
      const paramsArr = [];
      for (const k in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(k)) {
          const v = params[k];
          if (v || v == 0) {
            paramsArr.push(k + "=" + encodeURIComponent(AesUtils.encrypt(v)));
          }
        }
      }
      if (paramsArr.length == 0) {
        return url;
      }
      url = url + "?" + paramsArr.join("&");
      return url;
    }

    request(method: string, data: any, callback: any) {
      if (!this.address) {
        this.address = this.getAddress();
      }
      let url = this.address + method;
      data.client_channel = '9';
      data.api_version = 1;
      data.client = Platform.client;
      data.timeNowClient = Date.now();
      url = this.buildUrl(url, data);

      axios.get(url).then((res) => {
        if (res.status == 200) {
          let result = AesUtils.decrypt(res.data);
          result = JSON.parse(result);
          callback && callback(null, result);
        }
      });
    }
  };
  return new ApiNetWork();
};

export const ApiNetWork = createImNetWork();

export default ApiNetWork;
